import { inject, createVNode } from "vue";
import PropsTypes from '../_util/vue-types';
import { getComponent, getSlot } from '../_util/props-util';
import { ConfigConsumerProps } from '../config-provider';
export var CommentProps = {
  actions: PropsTypes.array,

  /** The element to display as the comment author. */
  author: PropsTypes.any,

  /** The element to display as the comment avatar - generally an antd Avatar */
  avatar: PropsTypes.any,

  /** The main content of the comment */
  content: PropsTypes.any,

  /** Comment prefix defaults to '.ant-comment' */
  prefixCls: PropsTypes.string,

  /** A datetime element containing the time to be displayed */
  datetime: PropsTypes.any
};
var Comment = {
  name: 'AComment',
  props: CommentProps,
  setup: function setup() {
    return {
      configProvider: inject('configProvider', ConfigConsumerProps)
    };
  },
  methods: {
    getAction: function getAction(actions) {
      if (!actions || !actions.length) {
        return null;
      }

      var actionList = actions.map(function (action, index) {
        return createVNode("li", {
          "key": "action-".concat(index)
        }, [action]);
      });
      return actionList;
    },
    renderNested: function renderNested(prefixCls, children) {
      return createVNode("div", {
        "class": "".concat(prefixCls, "-nested")
      }, [children]);
    }
  },
  render: function render() {
    var customizePrefixCls = this.$props.prefixCls;
    var getPrefixCls = this.configProvider.getPrefixCls;
    var prefixCls = getPrefixCls('comment', customizePrefixCls);
    var actions = getComponent(this, 'actions');
    var author = getComponent(this, 'author');
    var avatar = getComponent(this, 'avatar');
    var content = getComponent(this, 'content');
    var datetime = getComponent(this, 'datetime');
    var avatarDom = createVNode("div", {
      "class": "".concat(prefixCls, "-avatar")
    }, [typeof avatar === 'string' ? createVNode("img", {
      "src": avatar,
      "alt": "comment-avatar"
    }, null) : avatar]);
    var actionDom = actions ? createVNode("ul", {
      "class": "".concat(prefixCls, "-actions")
    }, [this.getAction(Array.isArray(actions) ? actions : [actions])]) : null;
    var authorContent = createVNode("div", {
      "class": "".concat(prefixCls, "-content-author")
    }, [author && createVNode("span", {
      "class": "".concat(prefixCls, "-content-author-name")
    }, [author]), datetime && createVNode("span", {
      "class": "".concat(prefixCls, "-content-author-time")
    }, [datetime])]);
    var contentDom = createVNode("div", {
      "class": "".concat(prefixCls, "-content")
    }, [authorContent, createVNode("div", {
      "class": "".concat(prefixCls, "-content-detail")
    }, [content]), actionDom]);
    var comment = createVNode("div", {
      "class": "".concat(prefixCls, "-inner")
    }, [avatarDom, contentDom]);
    var children = getSlot(this);
    return createVNode("div", {
      "class": prefixCls
    }, [comment, children && children.length ? this.renderNested(prefixCls, children) : null]);
  }
};
/* istanbul ignore next */

Comment.install = function (app) {
  app.component(Comment.name, Comment);
};

export default Comment;